import { Link } from 'react-router-dom';
import type { Category } from '@/types/domain';
import { resolveMediaUrl } from '@/utils/media';
import { Icon } from '@/components/atoms';
import { categoryIcon } from '@/i18n/categories';
import styles from './CategoryGrid.module.css';

export interface CategoryGridProps {
  categories: Category[];
}

/**
 * F-141 + F-160 (C2): tile renders the AI-generated `hero_image_url` as a
 * background image when present, with a darkened gradient overlay for
 * legibility. When the hero is missing we fall back to a Lucide SVG via
 * `<Icon name=…/>` instead of the legacy emoji (R2 no-emoji-as-iconography).
 */
export function CategoryGrid({ categories }: CategoryGridProps): JSX.Element {
  return (
    <div className={styles.grid}>
      {categories.map((cat) => {
        const hasHero = Boolean(cat.hero_image_url);
        const style = hasHero
          ? ({ '--cat-hero': `url(${resolveMediaUrl(cat.hero_image_url)})` } as React.CSSProperties)
          : undefined;
        return (
          <Link
            key={cat.slug}
            to={`/c/${cat.slug}`}
            className={hasHero ? `${styles.tile} ${styles.tileWithHero}` : styles.tile}
            style={style}
          >
            {hasHero ? null : (
              <span className={styles.icon} aria-hidden>
                <Icon name={categoryIcon(cat.slug)} size={28} strokeWidth={1.75} />
              </span>
            )}
            <span className={styles.name}>{cat.name_ua}</span>
            {cat.spec_count !== undefined ? (
              <span className={styles.count}>{cat.spec_count} спеціалістів</span>
            ) : null}
          </Link>
        );
      })}
    </div>
  );
}
